import React, { useState, useMemo, useEffect, useCallback } from "react";
import DataTable from "@/components/dataTableComponents/DataTable";
import { Box, Grid, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import FilterForm from "@/pages/attendanceManagement/adminAttendanceMuster/FilterForm";
// import FilterForm from "@/pages/employeeList/components/FilterForm";
import { StyledButton } from "@/components";
import AddLOP from "./components/AddLOP";
import AddLopModal from "./components/AddLopModal";
import Import from "./components/Import";
import ProcessAttendance from "./components/ProcessAttendance";
import FilterButton from "@/components/filter/FilterButton";
import { useGetAttendanceMusterQuery, useLazyGetDownloadMusterExcelQuery, useLazyGetSampleExcelQuery, useMusterImportMutation, useLazyGetLopSampleExcelQuery } from "@/api/services/attendanceManagement/muster/Muster";
import DialogForm from "@/components/modal/DialogForm";
import { format, eachDayOfInterval, isValid, parseISO } from 'date-fns';
import { useGetPayrollLockDateInfoQuery, useGetPayrollLockDateQuery } from "@/api/services/attendance/calendar/Calendar";
import { useFetchSettingsRowsQuery } from "@/api/services/Settings/business/Business";
import { DownloadIcon } from "@/icons";
import useFetchCommonData from "@/hooks/useFetchCommonData";
import { useCommonApiQuery } from "@/api/services/commonApi/CommonApi";
import {
  useEmployeesUnderRMQuery,
  useReportingManagerUnderReviewerQuery,
} from "@/api/services/employeeList/EmployeeList";
import { useSelector } from "react-redux";
import mapOptions from "@/utils/mappers/mapOptions";
import * as XLSX from 'xlsx';
import moment from "moment";
import CommonDataTable from "@/components/dataTableComponents/NewDatatablePagination";
import { minWidth } from "@mui/system";
import { useGetMusterDynamicHeadersQuery } from "@/api/services/attendance/muster/Muster";

const AttendanceDetails = () => {

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [filterVisible, setFilterVisible] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [openDialog1, setOpenDialog1] = useState(false);
  const [openDialog2, setOpenDialog2] = useState(false);
  const [openAddLopModal, setOpenAddLopModal] = useState(false);
  const [dataTableKey, setDataTableKey] = useState(0);
  const [dynamicDateColumns, setDynamicDateColumns] = useState([]);
  const [visibleColumns, setVisibleColumns] = useState([]);
  const toggleFilter = () => setFilterVisible(!filterVisible);
  const [selectedMonth, setSelectedMonth] = useState(moment().format("MM-YYYY"));
   const [loadingExcel, setLoadingExcel] = useState(false);

  const { data: payrollMonthData, refetch: refetchPayrollMonth } = useGetPayrollLockDateQuery({
    yearMonth: selectedMonth,
  }, { skip: !selectedMonth });
  const payrollMonth = payrollMonthData?.data?.payrollMonth || {};
  const [downloadSampleExcel] = useLazyGetSampleExcelQuery();
  const [downloadExcel, { isFetching }] = useLazyGetDownloadMusterExcelQuery();
  const [downloadLopSample] = useLazyGetLopSampleExcelQuery();
  const [sampleModalOpen, setSampleModalOpen] = useState(false);
  const [sampleType, setSampleType] = useState("muster");

  // options list datas
  const localStorageData = JSON.parse(localStorage.getItem("loginDetails"));
  const employeeDetails = localStorageData?.userDetails || {};
  const orgCode =
    Array.isArray(employeeDetails?.organizationAccess) &&
      employeeDetails.organizationAccess.length > 0
      ? employeeDetails.organizationAccess[0]?.organizationCode
      : null;

  //  const initialFilterData = useMemo(() => ({}), []);
  const initialFilterData = useMemo(() => {
    return {
      empId: "",
      reviewer: "",
      repManager: "",
      payrollStatus: "",
    };
  }, []);
  const [filterData, setFilterData] = useState(initialFilterData);
  const [selectedReviewer, setSelectedReviewer] = useState(null);
  const [selectedRM, setSelectedRM] = useState(null);
  const [loading, setLoading] = useState(false);

  // hr info getReportingManagerUnderReviewer
  const { data: fetchReviewers } = useFetchCommonData("REVIEWER");

  const { data: fetchAllEmployees } = useFetchCommonData("ALLEMPLOYEES");

  // RM under RW
  const {
    data: fetchReportingManagerUnderReviewer,
    isLoading: reportingManagerUnderReviewerLoading,
  } = useReportingManagerUnderReviewerQuery(selectedReviewer, {
    skip: !selectedReviewer,
  });

  // EMP UNDER RM

  const { data: fetchEmployeesUnderReportingManager } =
    useEmployeesUnderRMQuery(selectedRM, {
      skip: !selectedRM,
    });

  const { data: fetchPayroll } = useFetchCommonData("PAYROLL_STATUS", {
    org: orgCode,
  });

  // Memoized options for the "Rep.Manager" dropdown
  const reportingManagerOptions = useMemo(() => {
    return fetchReportingManagerUnderReviewer &&
      fetchReportingManagerUnderReviewer.length > 0
      ? mapOptions(fetchReportingManagerUnderReviewer)
      : [];
  }, [fetchReportingManagerUnderReviewer]);

  // Dynamically set fetchActiveEmployee based on selectedRM
  const fetchActiveEmployee = useMemo(() => {
    return selectedRM
      ? fetchEmployeesUnderReportingManager || []
      : fetchAllEmployees || [];
  }, [selectedRM, fetchEmployeesUnderReportingManager, fetchAllEmployees]);

  // Memoized condition to disable "Rep.Manager"
  const isRepManagerDisabled = useMemo(
    () => !selectedReviewer || reportingManagerUnderReviewerLoading,
    [selectedReviewer, reportingManagerUnderReviewerLoading]
  );

  // filters
  const handleFilterChange = useCallback((event) => {
    const { name, value } = event.target;

    setFilterData((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));

    if (name === "reviewer") {
      setSelectedReviewer(value);
    }
    if (name === "reportingManagerId") {
      setSelectedRM(value);
    }
    setCurrentPage(0);
  }, []);

  // Handle page change
  const handlePageChange = useCallback((newPage) => {
    setCurrentPage(newPage);
  }, []);

  const handleRowsPerPageChange = useCallback((newSize) => {
    setPageSize(newSize);
    setCurrentPage(0);
  }, []);

  const finalQuery = useMemo(() => ({
    ...(filterData.empId ? { empId: filterData.empId } : {}),
    ...(filterData.reviewer ? { reviewer: filterData.reviewer } : {}),
    ...(filterData.repManager ? { repManager: filterData.repManager } : {}),
    ...(filterData.payrollStatus ? { payrollStatus: filterData.payrollStatus } : {}),
    ...(selectedMonth ? { yearMonth: selectedMonth } : {}),
    page: currentPage,
    size: pageSize,
    ...(searchText ? { search: searchText } : {}),
    sortDirection: "DESC",
  }), [filterData, selectedMonth, currentPage, pageSize, searchText]);

  const {
    data: attendanceMusterDetails = [],
    refetch: refetchEmpMuster,
    isLoading: attendanceMusterLoading,
    isFetching: attendanceMusterFetching,
    isUninitialized
  } = useGetAttendanceMusterQuery(finalQuery, {
    skip: !selectedMonth, // ensures query only runs when month is selected
  });

  const rows = attendanceMusterDetails?.data?.content || [];
  const totalRows = attendanceMusterDetails?.data?.totalElements || 0;
  const pageCount = attendanceMusterDetails?.data?.totalPages || Math.ceil(totalRows / pageSize);

  const { data: dynamicHeadersData = [] } = useGetMusterDynamicHeadersQuery();
  const dynamicHeaders = dynamicHeadersData?.data || [];

  const refetchData = async () => {
    setLoading(true);
    try {
      await refetchEmpMuster();
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isUninitialized) {
      refetchData();
    }
  }, [finalQuery, isUninitialized]);


  const filterConfig = useMemo(
    () => [
      {
        name: "empId",
        label: "Select Employee",
        type: "select",
        placeholder: "Select Employee",
        options: mapOptions(fetchActiveEmployee || []),
        onChange: handleFilterChange,
      },
      {
        name: "reviewer",
        label: "Select Reviewer",
        type: "select",
        options: mapOptions(fetchReviewers),
        placeholder: "Select Reviewer",
        onChange: handleFilterChange,
      },
      {
        name: "repManager",
        label: "Select Rep.Manager",
        type: "select",
        placeholder: "Select Rep.Manager",
        options: reportingManagerOptions,
        onChange: handleFilterChange,
        disable: isRepManagerDisabled,
      },
      {
        name: "payrollStatus",
        label: " Select Pay Roll Status",
        type: "select",
        options: mapOptions(fetchPayroll || []),
        required: false,
        placeholder: "Select Pay Roll Status",
        onChange: handleFilterChange,
      },
      {
        name: "startDate",
        label: "Select Month & Year",
        type: "month",
        placeholder: "Select Month & Year",
      },

    ],
    [
      fetchReviewers,
      reportingManagerOptions,
      fetchActiveEmployee,
      isRepManagerDisabled,
      handleFilterChange,
    ]
  );

  const handleOpen = () => {
    setOpenDialog(!openDialog);
  }
  const handleOpen1 = () => {
    setOpenDialog1(!openDialog1);
  }
  const handleOpen2 = () => {
    setOpenDialog2(!openDialog2);
  }

  useEffect(() => {
    if (payrollMonth?.startDate && payrollMonth?.endDate) {
      const startDate = parseISO(payrollMonth.startDate);
      const endDate = parseISO(payrollMonth.endDate);

      const columns = eachDayOfInterval({ start: startDate, end: endDate }).map((date) => ({
        field: format(date, "yyyy-MM-dd"),
        headerName: format(date, "dd iiiiii"),
        minWidth: 10,
      }));

      setDynamicDateColumns(columns);
    }
  }, [payrollMonth]);

 const flattenRowData = (row) => {
  const formattedDOJ = (doj) => {
    if (!doj) return "";
    const dateObj = new Date(typeof doj === "string" ? doj.replace(" IST", "") : doj);
    return isNaN(dateObj.getTime()) ? "Invalid Date" : format(dateObj, "yyyy-MM-dd");
  };

  // Extract from leaveCounts dynamically
  const leaveCounts = row?.leaveCounts || {};
  const formattedLeaveCounts = Object.entries(leaveCounts).reduce((acc, [key, value]) => {
    acc[`${key}`] = value || 0;
    return acc;
  }, {});

  // Attendance mapping
  const attendanceMap = Object.fromEntries(
    row.attendanceData?.map(({ date, attendanceData }) => [date, attendanceData]) || []
  );

  return {
    employeeId: row.employeeId || "",
    employeeName: row.employeeName || "",
    designation: row.designation || "",
    manpowerOutsourcing: row.manpowerOutsourcing || "",
    billingType: row.billingType || "",
    repManagerId: row.repManagerId || "",
    repManagerName: row.repManagerName || "",
    doj: formattedDOJ(row.doj),
    location: row.location || "",
    month: row.month || "",
    totalPresentDays: row.totalPresentDays || 0,
    totalLOP: row.totalLOP || 0,
    weekOff: row.weekOff || 0,
    totalHolidays: row.totalHolidays || 0,
    totalDays: row.totalDays || 0,
    totalLeave: row.totalLeaveDays || 0,
    MaternityLeave: row["Maternity Leave"] || 0,
    ...formattedLeaveCounts, 
    // ...dynamicLeaveData,          
    ...attendanceMap               
  };
};

  const flattenedRows = rows.map(flattenRowData);
  const staticColumns1 = [
    { field: "employeeId", headerName: "Employee ID", minWidth: 150 },
    { field: "employeeName", headerName: "Employee Name", minWidth: 150 },
    { field: "repManagerId", headerName: "Rep ID", minWidth: 150 }, 
    { field: "repManagerName", headerName: "Rep Name", minWidth: 150 }, 
    { field: "designation", headerName: "Designation", minWidth: 150 },
    { field: "doj", headerName: "DOJ", minWidth: 150 },
    { field: "manpowerOutsourcing", headerName: "Manpower", minWidth: 150 }, 
    { field: "billingType", headerName: "Billing Type", minWidth: 150 }, 
    { field: "location", headerName: "Location", minWidth: 150 },
    { field: "month", headerName: "Month", minWidth: 150 }, // Remove if not needed
  ];

  const toPascalCase = (label) =>
  label.replace(/\s+/g, "").replace(/^\w/, (c) => c.toUpperCase());

 const dynamicLeaveColumns = Object.entries(dynamicHeaders).map(
  ([shortCode, label]) => ({
    field: label,
    headerName: label,                   
  })
 );

  const staticColumns2 = [
    { field: "totalPresentDays", headerName: "Total No Of Present Days" },
    { field: "totalLOP", headerName: "Total LOP" },
    { field: "weekOff", headerName: "Week Off" },
    { field: "totalHolidays", headerName: "Total Holidays" },
    { field: "totalDays", headerName: "Total Days" },
  ];

  const staticColumns3 = [
    { field: "MaternityLeave", headerName: "Maternity Leave" },
    { field: "Paternity Leave", headerName: "Paternity Leave" },
    { field: "Comp Off", headerName: "Comp Off" },
    { field: "RestrictedHoliday", headerName: "Restricted Holiday" },
    { field: "totalLeave", headerName: "Total Leave" },
  ];

  const columns = useMemo(() => {
    return [...staticColumns1, ...dynamicDateColumns, ...staticColumns2, ...dynamicLeaveColumns, ...staticColumns3];
  }, [dynamicDateColumns, staticColumns1, staticColumns2, dynamicLeaveColumns, staticColumns3]);



  useEffect(() => {
    const newVisibleColumns = columns.map((column) => ({ ...column, visible: true }));
    if (JSON.stringify(newVisibleColumns) !== JSON.stringify(visibleColumns)) {
      setVisibleColumns(newVisibleColumns);
    }
  }, [columns]);

  const handleToggleColumn = (field) => {
    setVisibleColumns((prevColumns) =>
      prevColumns.map((column) =>
        column.field === field
          ? { ...column, visible: !column.visible }
          : column
      )
    );
  };
  const renderedColumns = visibleColumns.filter((column) => column.visible);

  useEffect(() => {
    setDataTableKey((prev) => prev + 1)
  }, [visibleColumns])

  // Reset pagination when month changes
  useEffect(() => {
    setCurrentPage(0);
  }, [selectedMonth]);

  const handleDownload = (sampleData, fileName) => {
    if (!sampleData || !(sampleData instanceof Blob)) {
      return;
    }
    const url = URL.createObjectURL(sampleData);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleDownloadMuster = async (fileName) => {
    const response = await downloadExcel({ yearMonth: selectedMonth }).unwrap();
    // if (!sampleData || !(sampleData instanceof Blob)) {
    //   return;
    // }
    const url = URL.createObjectURL(response);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const renderContent = () => {
    return (
      <>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Grid container spacing={2} alignItems="center">

            <Grid item xs={12} sm={8} md={8} lg={8}>
              <Box display="flex" alignItems="center" gap={2}>
                <FilterButton
                  onClick={toggleFilter}
                  sx={{ margin: "10px 0", padding: "3px" }}
                />

                <StyledButton
                  label="Process Attendance"
                  onClick={handleOpen2}
                  size="small"
                  variant="outlined"
                  type="button"
                  sx={{
                    width: "185px",
                    height: "32px",
                    border: "none",
                    background: "hsl(142,35%,94%)",
                    "&:hover": {
                      color: "hsl(145,38%,21%)",
                      border: "none",
                      background: "hsl(142,35%,94%)",
                    },
                  }}
                />

                <StyledButton
                  label="Sample Excel"
                  onClick={() => { setSampleType("muster"); setSampleModalOpen(true); }}
                  size="small"
                  variant="outlined"
                  type="button"
                  sx={{
                    width: "185px",
                    height: "32px",
                    borderRadius: "4px",
                    // ml: 2
                  }}
                />

                <StyledButton
                  icon={<DownloadIcon />}
                  label="Download Excel"
                  onClick={() => handleDownloadMuster("downloadMuster.xlsx")}
                  size="small"
                  variant="outlined"
                  type="button"
                  isSubmitting={isFetching}
                  sx={{
                    width: "185px",
                    height: "32px",
                    ml: 2,
                    borderRadius: "4px",
                    color: "hsl(38,92%,50%)",
                    background: "rgb(253,239,214)",
                    border: "1px solid hsl(38,92%,50%)",
                    "&:hover": {
                      color: "hsl(38,92%,50%)",
                      background: "rgb(253,239,214)",
                      border: "1px solid hsl(38,92%,50%)",
                    },
                  }}
                />
              </Box>
            </Grid>

            {/* Right side buttons */}
            <Grid item xs={12} sm={4} md={4} lg={4} sx={{ textAlign: "right" }}>
              <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2}>
                <StyledButton
                  label="Add LOP"
                  type="button"
                  sx={{
                    width: "130px",
                    height: "32px",
                  }}
                  onClick={() => setOpenAddLopModal(true)}
                />
                <StyledButton
                  label="Import"
                  type="button"
                  sx={{
                    width: "130px",
                    height: "32px",
                  }}
                  onClick={handleOpen1}
                />
                <StyledButton
                  label="Reverse LOP"
                  type="button"
                  sx={{
                    width: "130px",
                    height: "32px",
                  }}
                  onClick={handleOpen}
                />
              </Box>
            </Grid>
          </Grid>

        </Box>

        {/* Filter component */}
        {filterVisible && (
          <FilterForm fields={filterConfig} selectedMonth={selectedMonth} setSelectedMonth={setSelectedMonth} setCurrentPage={setCurrentPage}
            onReset={() => {
              setFilterData(initialFilterData);
              setCurrentPage(0);
            }} />
        )}

        <CommonDataTable
          columns={renderedColumns}
          rows={flattenedRows}
          checkbox={false}
          search={false}
          loading={loading || attendanceMusterLoading}
          // onSearchChange={handleSearchChange}
          pageCount={pageCount}
          totalRecords={totalRows}
          onPageChange={handlePageChange}
          onPageSizeChange={handleRowsPerPageChange}
          currentPage={currentPage}
          currentPageSize={pageSize}
        />
      </>
    );
  };



  const handleSampleDownload = async () => {
    if (sampleType === "muster") {
      const response = await downloadSampleExcel().unwrap();
      handleDownload(response, "muster-sample.xlsx");
    } else {
      const response = await downloadLopSample().unwrap();
      handleDownload(response, "lop-sample.xlsx");
    }
    setSampleModalOpen(false);
  };

  return <>
    {renderContent()}
    <AddLOP open={openDialog} setOpen={setOpenDialog} fetchActiveEmployee={fetchActiveEmployee} />
    <AddLopModal open={openAddLopModal} setOpen={setOpenAddLopModal} />
    <Import open={openDialog1} setOpen={setOpenDialog1} />
    <ProcessAttendance open={openDialog2} setOpen={setOpenDialog2} fetchActiveEmployee={fetchActiveEmployee} />
    <DialogForm
      title="Download Sample Excel"
      open={sampleModalOpen}
      setOpen={setSampleModalOpen}
      width="xs"
    >
      <RadioGroup  row value={sampleType} onChange={(e) => setSampleType(e.target.value)}>
        <FormControlLabel value="muster" control={<Radio />} label="Muster" />
        <FormControlLabel value="lop" control={<Radio />} label="LOP" />
      </RadioGroup>
      <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
        <StyledButton label="Cancel" onClick={() => setSampleModalOpen(false)} variant="outlined" size="small" />
        <StyledButton label="Download" onClick={handleSampleDownload} size="small" />
      </Box>
    </DialogForm>
  </>;

};

export default AttendanceDetails;
